import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/apr-calculator',
  component: () => import('../../routes/AprCalculator.svelte'),
  card: {
    id: 'apr-calculator',
    title: 'APR Calculator',
    description: 'Calculate the true annual percentage rate of a loan, accounting for interest rate and upfront fees. See the real cost of borrowing beyond the stated rate.',
    icon: 'calculate',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/apr-calculator',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'APR Calculator – Annual Percentage Rate Calculator',
    description: 'Free APR calculator to find the true annual percentage rate of any loan. Enter loan amount, interest rate, term, and fees to compare the real cost of borrowing.',
  },
};

export default meta;
